import {get, post} from "../APIGateWay";

export async function getLeaderboard(params = {}) {
    return await get(params, '/leaderboard')
}

export async function getContestLeaderboard(params = {}) {
    return await get(params, '/contest/leaderboard')
}